import { Region } from '@/auth/constants';
const isRegion = (value) => Object.values(Region).includes(value);
export const formatTenantSettingsResponse = (result) => {
    if (!isRegion(result === null || result === void 0 ? void 0 : result.auth0Region)) {
        return Object.assign(Object.assign({}, result), { auth0Region: Region.US });
    }
    return result;
};
